import { AsyncPipe, CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CanPipe } from 'ability';
import { I18NextPipe } from 'angular-i18next';
import { ButtonComponent, CheckboxComponent, ModalComponent, ModalFooterDirective } from 'mbs-ui-kit';
import { Balance } from 'mbs-ui-shared@components/components/models/license.model';
import { BALANCE_TOKEN } from 'mbs-ui-shared@components/licenses/tokens/balance.token';
import { Observable } from 'rxjs';
import { SubscribeUbComponent } from '../subscribe-ub-base';

@Component({
  selector: 'mbs-subscribe-ub-wasabi',
  templateUrl: './subscribe-ub-wasabi.component.html',
  styleUrls: ['./subscribe-ub-wasabi.component.scss'],
  imports: [
    AsyncPipe,
    ButtonComponent,
    CheckboxComponent,
    CommonModule,
    FormsModule,
    I18NextPipe,
    ModalComponent,
    CanPipe,
    ModalFooterDirective
  ]
})
export class SubscribeUbWasabiComponent extends SubscribeUbComponent {
  balance = inject<Observable<Balance>>(BALANCE_TOKEN);

  constructor() {
    super();
  }

  handleResolve(): void {
    super.handleResolve(this.acceptTerms, this.selectedStorageId, 'ubw_toc_agree');
  }
}
